import React, {useState, useEffect} from 'react';
import OrderTable from '../Components/OrderTable/OrderTable';

const MyOrders = () => {
  return (
    <div>
      <OrderTable/>
    </div>
  )
}

export default MyOrders